import React from 'react';
import IconSummaryGray from '../../../assets/dealroom-icons/summary-gray.svg';
import IconChangeGray from '../../../assets/dealroom-icons/change-gray.svg';

const AttorneyTextIntro = () => {
  return (
    <p className="text-gray preview-description">
      Below is the agreement that is being negotiated by this team. The Terms
      Summary provides an overview of the terms that are currently proposed. To
      review the actual agreement text, click on &nbsp;
      <img src={IconSummaryGray} alt="" />
      &nbsp; on the toolbar.
      <br />
      <br />
      To redline this agreement, hover over any portion of the text and click on
      “Edit.” Your redlines will be saved and viewed by everyone involved in
      this team. All parties must accept your redline before it becomes a
      permanent part of the agreement. Redlining on Cosynd is easily tracked and
      can be viewed by clicking on &nbsp;
      <img src={IconChangeGray} alt="" />
      &nbsp; from the toolbar.
      <br />
      <br />
      You should communicate directly with your client off of Cosynd - messages
      that you post on Cosynd can be seen by everyone involved in this
      agreement.
    </p>
  );
};

export default AttorneyTextIntro;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/AttorneyTextIntro.js